<template>
  <div :id="`quality-indicator-${callId}`" class="indicator-wrapper">
    <div
        v-for="(bar, index) in indicatorBarsConfig"
        :key="bar"
        class="indicator-item"
        :class="{filled: value >= bar, 'low-quality': value >= bar && value < LOW_QUALITY_VALUE}"
        :style="{height: `${(index + 1) * 4}px`}"
    />
  </div>
</template>

<script>
const LOW_QUALITY_VALUE = 3
const indicatorBarsConfig = [2.5, 3, 3.5, 3.75, 4]

export default {
  name: "AudioQualityIndicator",
  props: {
    callId: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      indicatorBarsConfig,
      LOW_QUALITY_VALUE
    }
  }
}
</script>

<style scoped>
.indicator-wrapper {
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-end;
  width: 28px;
  height: 20px;
  margin: 0 5px;
}

.indicator-item:not(:first-child) {
   margin-left: 2px
 }

.indicator-item {
  width: 4px;
  border-radius: 2px;
  background-color: grey;
}

.indicator-item.filled {
  background-color: black;
}

.indicator-item.low-quality {
  background-color: red;
}
</style>
